import type { IconNode } from '../types';

/**
 * @name windmill
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAgMTQgOCA0IDItNEw0IDZsMi00IDggNCIgLz4KICA8cGF0aCBkPSJtOCA4LTQgOCA0IDIiIC8+CiAgPHBhdGggZD0ibTE2IDEyIDQtOC00LTJMNiAyMiIgLz4KICA8cGF0aCBkPSJtMTkgMjItMi40LTQuNiIgLz4KICA8cGF0aCBkPSJNMTIuNSAyMHYyIiAvPgogIDxwYXRoIGQ9Ik00IDIyaDE3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/windmill
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const windmill: IconNode = [
  ['path', { d: 'm10 14 8 4 2-4L4 6l2-4 8 4', key: 'wrh1ap' }],
  ['path', { d: 'm8 8-4 8 4 2', key: '11za4r' }],
  ['path', { d: 'm16 12 4-8-4-2L6 22', key: 'iy2aa6' }],
  ['path', { d: 'm19 22-2.4-4.6', key: '1d0oyr' }],
  ['path', { d: 'M12.5 20v2', key: 'ldheyx' }],
  ['path', { d: 'M4 22h17', key: '160loe' }],
];

export default windmill;
